export const getCurrencySymbol = (currencyCode) => {
  switch (currencyCode?.toUpperCase()) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "INR":
      return "₹";
    case "AED":
      return "د.إ";
    default:
      return currencyCode ? `${currencyCode} ` : "";
  }
};

export const formatMoney = (amount, currencyCode) => {
  if (amount === null || amount === undefined || amount === "") {
    return "N/A";
  }
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${amount}`;
};

// AI usage costs are often fractions of a cent: below 1 keep two significant digits
// ("$0.0021", "$0.010") so a real cost never shows as "$0.00" and small per-question
// costs stay comparable; from 1 up, two decimals.
export const formatAICost = (amount, currencyCode = "USD") => {
  const value = Number(amount);
  const symbol = getCurrencySymbol(currencyCode);
  if (!Number.isFinite(value) || value === 0) return `${symbol}0.00`;
  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);
  if (abs >= 1) {
    return `${sign}${symbol}${abs.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  const decimals = Math.max(2, 1 - Math.floor(Math.log10(abs)));
  return `${sign}${symbol}${Number(abs.toPrecision(2)).toFixed(decimals)}`;
};
